import _isString from 'lodash/isString';
import _trimEnd from 'lodash/trimEnd';

const customizationElementsMapper = (params) => {
  const { elementUUIDs, formValues } = params;
  const elements = [];
  elementUUIDs.forEach((elementUUID) => {
    if (formValues && formValues[elementUUID]) {
      const element = { ...formValues[elementUUID] };
      const elementBody = element.body;
      if (_isString(elementBody)) {
        // remove any trailing newlines, they have the potential to break pdf render
        const trimmedElementBody = _trimEnd(elementBody, '\n');
        element.body = trimmedElementBody;
      }
      elements.push(element);
    }
  });


  return elements;
};
export default customizationElementsMapper;



// WEBPACK FOOTER //
// ./src/cards/sagas/helpers.js